import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ContentService, AuthenticationService, NotificationService} from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './content-list.component.html' })
export class ContentListComponent implements OnInit {
  newContentForm: FormGroup;
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;
  contentList: [];
  filterable = {
    name: ''
  };

  constructor(private fb: FormBuilder,
    private authSvc: AuthenticationService,
    private contentSvc: ContentService,
    private notification: NotificationService,
    private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  openModal(targetModal) {
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newContentForm = this.fb.group({
      name: ['', Validators.required],
      description: ['']
    });
  }

  get f() { return this.newContentForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    this.filterable = {
      name: ''
    };
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  deleteContent(meta){
    if (confirm("Are you sure to delete this content?")) {
      this.contentSvc.deleteContent(meta.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Content deleted successfully!", "Delete Content");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting content, please try again later.", "Error");
        }
      })
    }
  }
  onSubmit() {
    this.processing = true;
    var newDataParam = this.newContentForm.getRawValue();
    if (this.newContentForm.valid) {
      if (confirm("Are you sure to add the content meta now?")) {
        this.contentSvc.addContent(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Meta added successfully!", "New Meta");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add meta, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.contentList = [];
    let params = this.formParam(page);

    // get page of items from api
    this.contentSvc.getAllContent(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.contentList = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      name: this.filterable.name
    }
    return params;
  }

}
